import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Action } from '../actions';
import { GRID_SCREEN_HANDLE_BULK_ITEMS } from '../actions/grid-screen';
import { GridAction } from '../typings/grid';

export const ofGridScreenBulkActionType = (...massActionTypes: GridAction[]): OperatorFunction<Action, Action> => {
    return filter(
        (action: Action) => action.type === GRID_SCREEN_HANDLE_BULK_ITEMS && massActionTypes.includes(action.bulkAction)
    );
};
